// ============================================================================
// useRouteTracking — MS-09a
// ----------------------------------------------------------------------------
// Registra cada navegação na tabela `page_view_log` para auditoria de uso real
// de rotas (incluindo redirects). Insere de forma "fire-and-forget" — falhas
// nunca bloqueiam a UI nem geram erro visível.
//
// Política:
//   • Só registra usuários autenticados (RLS exige user_id).
//   • Deduplica navegações sucessivas para a MESMA rota em <2s (evita ruído).
//   • Não bloqueia, não retry, não logs no console em sucesso.
// ============================================================================

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

const DEDUPE_WINDOW_MS = 2000;

export function useRouteTracking(): void {
  const location = useLocation();
  const { user } = useAuth();
  const lastRef = useRef<{ route: string; ts: number } | null>(null);

  useEffect(() => {
    if (!user?.id) return;
    const route = location.pathname;
    const now = Date.now();
    const last = lastRef.current;
    if (last && last.route === route && now - last.ts < DEDUPE_WINDOW_MS) return;
    lastRef.current = { route, ts: now };

    // Fire-and-forget — não esperar resposta, ignorar erros silenciosamente.
    void supabase
      .from("page_view_log")
      .insert({ route, user_id: user.id })
      .then(() => {
        /* ok */
      });
  }, [location.pathname, user?.id]);
}
